import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, IconButton, Paper, Typography, Box, FormHelperText, SwipeableDrawer, Divider, Avatar, Alert, AlertTitle, Stack } from '@mui/material';
// import Topbanner from '../../images/main-banner.png';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import PastWinner from '../../components/diwali/pastWinner';

import Terms from '../../components/diwali/t&cIndex';
import ButtonComponent from '../../components/diwali/buttonBottom';
import UserDetail from '../../components/diwali/userDetail';

import Button from '@mui/material/Button';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// import BG from '../../images/diwali/leaderbgs.png';
import EmptyPopUp from "../../components/diwali/emptyPopup";
import DataPopUp from "../../components/diwali/DataPopup";
import { getRandomName, namesArray } from './namesArray';
const BG= "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/top-section.png";
const AvatarImage = "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/avator12.png";

const PastWinnerBg ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/pastwinner-bg.png";
const PastWinnerText ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/past-winner.png";
const Heading ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/register-heading.png";
const Assured ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/assured.png";
const AboutPrize= "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/about-prize.png";
const Footer ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/footer.png";
const background ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/leaderboard-hero-bg.png";
const BikeImage ="https://d2sriifpjiqv0p.cloudfront.net/diwali2026/Prizes.gif";
const AvatarImage1 = "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/Avator1.png";
const AvatarImage2 = "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/Avator2.png";
const AvatarImage3 = "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/Avator3.png";
const AvatorBg = "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/avator-bg.png";
const borderline = 'https://d2sriifpjiqv0p.cloudfront.net/diwali2026/Line 124.png';
const TermImg = 'https://d2sriifpjiqv0p.cloudfront.net/diwali2026/term-white.png';
const BorderIMG = "https://d2sriifpjiqv0p.cloudfront.net/diwali2026/border.png";
const Leaderbd = 'https://d2sriifpjiqv0p.cloudfront.net/diwali2026/lb.png';


const leaderboardData = [
    { name: 'YOU', rank: '1000', points: '99,999', avatar: AvatarImage1, highlight: true },
    { name: 'Komal Sunil...', rank: '01', points: '01', avatar: AvatarImage2 },
    { name: 'Komal Sunil...', rank: '01', points: '01', avatar: AvatarImage3 },
    // Add more data as needed...
];
export default function Signup() {


    const navigate = useNavigate();


    const [checked, setChecked] = useState(true); // Set initial state to true for pre-checking

    const [leaderboard, setLeaderboard] = useState([]);
    const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([])
    const [userData, setUserData] = useState(null);
    const [openTermsCondition, setOpenTermsCondition] = useState(false);
    const [openDataPopup, setOpenDataPopup] = useState(false);
    const scrollToElementt = () => { formReff.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    const formReff = useRef(null);

    const params = new URLSearchParams(window.location.search);
    const ck_id = params.get('ck_id') || localStorage.getItem('savings_ck_id_dec');


    const fetchLeaderboard = async () => {
        try {
            const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl?ck_id=${ck_id}`);
            const data = await response.json();

            data.rows.unshift({
                name: "YOU",
                rank: data?.user_data?.user?.leaderboards_saving_league_dec?.rank,
                points: data?.user_data?.user?.leaderboards_saving_league_dec?.points,
                users_saving_league: { avatar: data?.user_data?.user?.avatar },
                highlight: true
            })

            setLeaderboard(data.rows); // Set leaderboard data
            setUserData(data.user_data.user); // Set user data
            console.log('========>', data)
            // console.log(data)

            // Store individual user_data fields in localStorage
            if (data.user_data.user.leaderboards_saving_league_dec) {
                const user = data.user_data.user.leaderboards_saving_league_dec;
                localStorage.setItem('savings_points', user.points);
                localStorage.setItem('savings_rank', user.rank);
                localStorage.setItem('savings_transactions', user.transactions);
                localStorage.setItem('savings_total_order_value', user.total_order_value);
                localStorage.setItem('savings_brand_discovery', user.brand_discovery);
                localStorage.setItem('savings_current_streak', user.current_streak);
                localStorage.setItem('milestone_1', data?.user_data?.user.milestone_1)
                localStorage.setItem('milestone_2', data?.user_data?.user.milestone_2)
                localStorage.setItem('milestone_3', data?.user_data?.user.milestone_3)
                localStorage.setItem('milestone_4', data?.user_data?.user.milestone_4)
                localStorage.setItem('milestone_5', data?.user_data?.user.milestone_5)
                localStorage.setItem('milestone_6', data?.user_data?.user.milestone_6)
                localStorage.setItem('milestone_7', data?.user_data?.user.milestone_7)
                localStorage.setItem('segment', data?.user_data?.user?.segment)
                localStorage.setItem('savings_visit_earn', user?.visit_earn * 10)
            }
        } catch (error) {
            console.error('Error fetching leaderboard:', error);
        }
    };

    const fetchWeeklyLeaderboard = async () => {
        try {
            const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl_week?week=4&ck_id=${ck_id}`)
            const data = await response.json()

            // console.log('====>', data?.user_data?.user)

            data.rows.unshift({
                name: "YOU",
                rank: data?.user_data?.user?.leaderboards_saving_league_snapshot_decs[0]?.rank,
                points: data?.user_data?.user?.leaderboards_saving_league_snapshot_decs[0]?.points,
                users_saving_league: { avatar: data?.user_data?.user?.avatar },
                highlight: true
            })
            setWeeklyLeaderboard(data?.rows)
            console.log(data?.rows)
        } catch (error) {
            console.error('Error fetching leaderboard:', error);
        }
    }



    useEffect(() => {




        fetchLeaderboard();
        fetchWeeklyLeaderboard()
    }, []);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const [selectedTab, setSelectedTab] = useState('Weekly');

    const handleTabClick = (tab) => {
        setSelectedTab(tab);
    };

    const handlePrizeClick = () => {
        if (userData && (userData?.leaderboards_saving_league_dec?.points)) {
            setOpenDataPopup(true)
        } else {
            setOpenTermsCondition(true)
        }
    }
    const updatedAt = new Date(userData?.leaderboards_saving_league_dec?.updatedAt);
    const formattedDate = updatedAt.getDate().toString().padStart(2, '0') + '/' +
        (updatedAt.getMonth() + 1).toString().padStart(2, '0') + '/' +
        updatedAt.getFullYear();

    localStorage.setItem('formated_date', formattedDate)

    console.log(`Last updated on ${formattedDate}`);

    return (
        <Grid container sx={{ background: '#fff' }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} sx={{
                background: '#16131B',
                width: '100%',
            }}>
                {/* <UserDetail /> */}
                <Grid>
                    <Box
                        sx={{
                            backgroundImage: "url('https://d2sriifpjiqv0p.cloudfront.net/diwali/top_bg.png')",
                            backgroundRepeat: 'no-repeat',
                            // webkitBackgroundSize: 'cover',
                            backgroundSize: '100% 100%', // Ensures the image covers the entire container
                            width: "100%",
                            padding: "20px 16px",
                            position: "relative",
                            zIndex: "22"
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '18%' }}>
                            <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/logo.png" alt='logo' style={{ width: '85%', }} />

                        </Box>
                        <Grid container spacing={2} sx={{ marginTop: '3%' }}>
                            <Grid item xs={4}>
                                <Box
                                    sx={{
                                        display: 'flex',         // Enable flexbox layout
                                        flexDirection: 'column', // Stack children vertically
                                        justifyContent: 'flex-end', // Align children to the end of the main-axis (bottom)
                                        backgroundImage: `url(${AvatorBg})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: '100% 100%', // Ensures the image covers the entire container
                                        minWidth: "104px",
                                        height: '196px',
                                        marginRight: '0',
                                        alignItems: "center"
                                    }}
                                >
                                    <Box sx={{
                                        overflow: "hidden",
                                        borderRadius: "16px",
                                        width: "90%",
                                        position: "relative",
                                        bottom: "5px"
                                    }}>
                                        {userData && <img
                                            src={require(`../../images/diwali/icon/Avator${userData?.avatar}.png`)}
                                            alt="Avatar"
                                            style={{
                                                width: '100%',
                                                height: '141px',
                                                objectFit: 'cover', // Ensure the image scales correctly
                                            }}
                                        />}
                                    </Box>
                                </Box>
                            </Grid>


                            <Grid item xs={8}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontFamily: 'Montserrat Alternates',
                                        fontWeight: '700',
                                        color: '#fff',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        lineHeight: '13px',
                                        textTransform: 'capitalize'
                                    }}
                                >
                                    {/* {userData?.leaderboards_saving_league_dec?.name} */}
                                    {userData?.leaderboards_saving_league_dec?.name || 'You'}
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                background: "linear-gradient(180deg, #FFD83E 0%, #F1A03A 100%)",
                                                borderRadius: '8px',
                                                padding: '8px',
                                                textAlign: 'center',
                                                // height: '64px',
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: 'Metropolis',
                                                    fontWeight: '500',
                                                    fontSize: '10px',
                                                    color: '#212121',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Total Points
                                                <img src={BorderIMG} alt='BorderIMG' style={{ width: '100%' }} />
                                            </Typography>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontFamily: '"Montserrat Alternates"',
                                                    fontWeight: '800',
                                                    color: '#212121',
                                                    fontSize: '1.5rem',
                                                    marginTop: '-7%'
                                                }}
                                            >
                                                {userData && userData?.leaderboards_saving_league_dec?.points || '0'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            sx={{
                                                background: " #FFFFFF33",
                                                borderRadius: '8px',
                                                padding: '8px',
                                                textAlign: 'center',
                                                // height: '64px',
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: 'Metropolis',
                                                    fontWeight: '500',
                                                    fontSize: '10px',
                                                    color: '#fff',
                                                    marginBottom: '4px',
                                                }}
                                            >
                                                Weekly Points
                                                <img src={BorderIMG} alt='BorderIMG' style={{ width: '100%' }} />
                                            </Typography>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontFamily: '"Montserrat Alternates"',
                                                    fontStyle: 'normal',
                                                    fontWeight: '800',
                                                    color: '#fff',
                                                    fontSize: '1.5rem',
                                                    marginTop: '-7%'
                                                }}
                                            >
                                                {userData && userData?.leaderboards_saving_league_dec?.rank || '0'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Box
                                    variant="contained"
                                    onClick={() => handlePrizeClick()}
                                    endIcon={<ArrowForwardIosIcon sx={{ fontSize: '0.75rem' }} />}
                                    sx={{
                                        background: 'linear-gradient(180deg, #FFD83E 0%, #F1A03A 100%)',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        textAlign:'center',
                                        marginTop: '6px',
                                        // justifyContent: 'space-between',                                        
                                    }}
                                >
                                    <Typography sx={{ color: '#212121',
                                        fontWeight: '500',
                                        // fontFamily: "Montserrat",
                                        fontSize: '10px',
                                        lineHeight:'13px',}} >Total Free Money</Typography>
                                    <Typography sx={{fontWeight:'800',fontSize:'24px', lineHeight:'13px', color:'#212121', paddingTop:'8px'}}>₹1,50,000</Typography>
                                </Box>
                                <Button
                                    variant="contained"
                                    onClick={() => handlePrizeClick()}
                                    endIcon={<ArrowForwardIosIcon sx={{ fontSize: '0.75rem' }} />}
                                    sx={{
                                        background: ' #FFFFFF33',
                                        fontWeight: '600',
                                        fontFamily: '"Montserrat Alternates"',
                                        fontSize: '0.75rem',
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        padding: '12px',
                                        marginTop: '6px',
                                        justifyContent: 'space-between',
                                        marginBottom: '1rem',
                                        fontStyle: "normal",
                                        boxShadow: 'none',
                                        '&:hover': {
                                            background: '#FFD833', // Keep the background same on hover
                                            boxShadow: 'none', // Remove any box-shadow on hover
                                        },
                                    }}
                                    fullWidth
                                >
                                    Prizes Claimed
                                </Button>

                            </Grid>
                        </Grid>
                        <Typography
                            variant="caption"
                            sx={{
                                fontFamily: 'Metropolis',
                                color: '#fff',
                                marginTop: '8px',
                                display: 'block',
                                fontSize: '8px',
                                fontWeight: '500',
                                textAlign: 'center'
                            }}
                        >
                            *Last updated on {formattedDate}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} px={2} pt={3} sx={{ position: 'relative' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => navigate('/diwali-league/prize-win')}
                        sx={{
                            background: 'linear-gradient(91.13deg, #FF1DA4 -9.57%, #97085D 121.67%)',


                            color: '#fff',
                            fontWeight: 600,
                            fontFamily: 'Metropolis',
                            textTransform: 'none',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            overflow: 'hidden', // To clip the image if necessary
                            height: '54px',
                            paddingLeft: '110px', // Add padding to make room for the image
                            position: 'relative',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                flexGrow: 1, // Ensures the text takes up remaining space
                                textAlign: 'right',
                                fontFamily: 'Metropolis'
                            }}
                        >
                            Prizes you can win
                        </Typography>
                        <ArrowRightAltIcon sx={{ fontSize: '24px' }} />
                    </Button>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '65%',
                            left: {
                                xs: '30px', // Adjust the position on smaller devices
                                sm: '50px', // Standard position on small and larger devices
                            },
                            transform: 'translateY(-50%)', // Center the image vertically
                            width: {
                                xs: '96px', // Smaller image on mobile devices
                                sm: '96px', // Standard image size on small and larger devices
                            },
                            height: {
                                xs: '96px', // Adjust the height to match the width
                                sm: '96px',
                            },
                        }}
                    >
                        <img
                            src="https://d2sriifpjiqv0p.cloudfront.net/diwali/logo.gif"
                            alt="Prize"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover', // Ensures the image covers the area proportionally
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} pt={3.5}>
                    <img src={Leaderbd} alt='Leaderbd' style={{ width: '100%', paddingLeft: '81px', paddingRight: '81px' }} />
                </Grid>
                <Grid item xs={12} sx={{ borderBottom: '1px solid #352066' }} pt={2}>
                    <Button
                        variant="text"
                        onClick={() => handleTabClick('Weekly')}
                        sx={{
                            color: selectedTab === 'Weekly' ? '#FFFFFF' : '#786B95',
                            fontWeight: selectedTab === 'Weekly' ? '600' : '600',
                            borderBottom: selectedTab === 'Weekly' ? '2px solid #7B1FA2' : 'none',
                            fontSize: '14px',
                            borderRadius: 0,
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRight: '1px solid #352066',
                            fontFamily: selectedTab === 'Weekly' ? 'Metropolis' : 'Metropolis',
                            textShadow: selectedTab === 'Weekly' ? '0px 0px 18px #FFFFFF' : 'none', // Apply white shadow when selected
                            width: '33%',
                            borderBottom: selectedTab === 'Weekly' ? 'none' : 'none',
                        }}
                    >
                        Weekly
                    </Button>

                    <Button
                        variant="text"
                        onClick={() => handleTabClick('Overall')}
                        sx={{
                            color: selectedTab === 'Overall' ? '#FFFFFF' : '#786B95',
                            fontWeight: selectedTab === 'Overall' ? '600' : '600',
                            borderBottom: selectedTab === 'Overall' ? '2px solid #7B1FA2' : 'none',
                            fontSize: '14px',
                            borderRadius: 0,
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRight: '1px solid #352066',
                            fontFamily: selectedTab === 'Overall' ? 'Metropolis' : 'Metropolis',
                            textShadow: selectedTab === 'Overall' ? '0px 0px 18px #FFFFFF' : 'none', // Apply white shadow when selected
                            width: '34%',
                            borderBottom: selectedTab === 'Overall' ? 'none' : 'none',
                        }}
                    >
                        Overall
                    </Button>
                    <a onClick={scrollToElementt}><Button
                        variant="text"
                        // onClick={() => handleTabClick('T&Cs')}
                        sx={{
                            color: selectedTab === 'T&Cs' ? '#FFFFFF' : '#786B95',
                            fontWeight: selectedTab === 'T&Cs' ? '600' : '600',
                            borderBottom: selectedTab === 'T&Cs' ? '2px solid #7B1FA2' : 'none',
                            fontSize: '14px',
                            borderRadius: 0,
                            textTransform: 'none',
                            padding: '8px 16px',
                            borderRight: '1px solid #352066',
                            fontFamily: selectedTab === 'T&Cs' ? 'Metropolis' : 'Metropolis',
                            textShadow: selectedTab === 'T&Cs' ? '0px 0px 18px #FFFFFF' : 'none', // Apply white shadow when selected
                            width: '33%',
                            borderBottom: selectedTab === 'T&Cs' ? 'none' : 'none',
                        }}
                    >
                        T&Cs
                    </Button></a>

                </Grid>

                <Box sx={{ width: '100%', paddingX: '12px', }} pt={3}>
                    <Grid container sx={{ paddingBottom: '16px', borderBottom: '1px solid #352066' }}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={4}>
                            <Typography
                                sx={{
                                    color: '#AEA2CA',
                                    fontFamily: 'Metropolis',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    textAlign: 'left',
                                }}
                            >
                                Name
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography
                                sx={{
                                    color: '#AEA2CA',
                                    fontFamily: 'Metropolis',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    textAlign: 'center',
                                }}
                            >
                                Rank
                            </Typography>
                        </Grid>
                        <Grid item xs={2.7}>
                            <Typography
                                sx={{
                                    color: '#AEA2CA',
                                    fontFamily: 'Metropolis',
                                    fontSize: '10px',
                                    fontWeight: '600',
                                    textAlign: 'right',
                                }}
                            >
                                Points
                            </Typography>
                        </Grid>
                        <Grid item xs={0.3}></Grid>
                    </Grid>

                    {selectedTab === 'Overall' && leaderboard && leaderboard.length > 0 ? (
                        leaderboard.map((entry, index) => (
                            <Grid
                                container
                                key={index}
                                sx={{
                                    height: '64px',
                                    background: entry.highlight ? 'linear-gradient(180deg, #8422BA 0%, #220A3A 100%)'
                                        : `url(${borderline}) no-repeat center bottom`,
                                    backgroundSize: "293px",
                                    borderRadius: entry.highlight ? '8px' : '0',
                                    marginBottom: entry.highlight ? '8px' : '0',
                                    boxShadow: entry.highlight ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }} px={1}>
                                    <Avatar
                                        src={require(`../../images/diwali/icon/Avator${entry?.users_saving_league_dec?.avatar || 4}.png`)}
                                        alt={entry?.name}
                                        sx={{
                                            width: entry.highlight ? '48px' : '40px',
                                            height: entry.highlight ? '52px' : '40px',
                                            marginRight: index === 0 ? '2px' : '8px',
                                            // paddingX: '7px',
                                            textAlign: 'left',
                                            borderRadius: entry.highlight ? '0px' : '100px',
                                            boxShadow: entry.highlight ? 'none' : '0px 0px 10px rgba(255, 255, 255, 0.5)',
                                            alignSelf: entry.highlight ? 'flex-end' : 'center',
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {userData.ck_id == entry?.ck_id ? "You" : entry?.name == 'You' || entry?.name == '' ? namesArray[index] : entry?.name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >
                                        {entry?.rank || '0'}
                                        { }
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} px={1}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >

                                        {entry?.points || '0'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))
                    ) : (
                        <Typography sx={{ color: '#FFFFFF', textAlign: 'center', }}>
                            {/* No leaderboard data available */}
                        </Typography>
                    )}

                    {selectedTab === 'Weekly' && weeklyLeaderboard && weeklyLeaderboard.length > 0 ? (
                        weeklyLeaderboard.map((entry, index) => (
                            <Grid
                                container
                                key={index}
                                sx={{
                                    height: '64px',
                                    background: entry.highlight ? 'linear-gradient(180deg, #8422BA 0%, #220A3A 100%)'
                                        : `url(${borderline}) no-repeat center bottom`,
                                    backgroundSize: "293px",
                                    borderRadius: entry.highlight ? '8px' : '0',
                                    marginBottom: entry.highlight ? '8px' : '0',
                                    boxShadow: entry.highlight ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }} px={1}>
                                    <Avatar
                                        src={require(`../../images/diwali/icon/Avator${entry?.users_saving_league_dec?.avatar || 4}.png`)}
                                        // src={require(`../../images/diwali/icon/Avator${entry?.users_diwali?.avatar}.png`)}
                                        // src={`../../images/diwali/icon/Avator${entry?.users_diwali?.avatar}.png`}

                                        alt={entry?.name}
                                        sx={{
                                            width: entry.highlight ? '48px' : '40px',
                                            height: entry.highlight ? '52px' : '40px',
                                            marginRight: index === 0 ? '2px' : '8px',
                                            // paddingX: '7px',
                                            textAlign: 'left',
                                            borderRadius: entry.highlight ? '0px' : '100px',
                                            boxShadow: entry.highlight ? 'none' : '0px 0px 10px rgba(255, 255, 255, 0.5)',
                                            alignSelf: entry.highlight ? 'flex-end' : 'center',
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            textAlign: 'center'
                                        }}
                                    >
                                        {userData?.ck_id == entry?.ck_id ? "You" : entry?.name == 'You' || entry?.name == '' ? namesArray[index] : entry?.name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >
                                        {entry?.rank || '0'}
                                        { }
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} px={1}>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontFamily: 'Metropolis',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                        }}
                                    >

                                        {entry?.points || '0'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))
                    ) : (
                        <Typography sx={{ color: '#FFFFFF', textAlign: 'center', mt: 2 }}>
                            {/* No leaderboard data available */}
                        </Typography>
                    )}

                </Box>
                <Grid item xs={12} pb={18} ref={formReff}>
                    <Box px={5} pt={6} pb={4}>
                        <img src={TermImg} alt='termImg' width={'100%'} />
                    </Box>

                    <Terms />
                </Grid>

                <ButtonComponent title="Start Collecting Points" url="/diwali-league/play-point" />

                <SwipeableDrawer
                    anchor="bottom"
                    open={openTermsCondition}
                    onClose={() => setOpenTermsCondition(false)}
                    onOpen={() => setOpenTermsCondition(true)}
                    variant="temporary"
                    disableSwipeToOpen={true}
                    ModalProps={{
                        keepMounted: false,
                    }}
                    sx={{ width: "100%", marginX: "10px" }}
                    PaperProps={{
                        elevation: 10,
                        style: { backgroundColor: "transparent" },
                    }}
                >
                    <EmptyPopUp setOpen={openTermsCondition} />
                </SwipeableDrawer>

                <SwipeableDrawer
                    anchor="bottom"
                    open={openDataPopup}
                    onClose={() => setOpenDataPopup(false)}
                    onOpen={() => setOpenDataPopup(true)}
                    variant="temporary"
                    disableSwipeToOpen={true}
                    ModalProps={{
                        keepMounted: false,
                    }}
                    sx={{ width: "100%", marginX: "10px" }}
                    PaperProps={{
                        elevation: 10,
                        style: { backgroundColor: "transparent" },
                    }}
                >
                    <DataPopUp setOpen={openDataPopup} />
                </SwipeableDrawer>


            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
            </Grid>
        </Grid>

    )
};